import getBrandConfig from '../../../config/brand';
import { getCookie } from '../../utils';

const brandConfig = getBrandConfig(process.env.BRAND_CHANNEL, process.env.LANG, process.env.SLOT, process.env.VENDOR); // eslint-disable-line
const visitorIdCookie = brandConfig.cookies.visitorId

const initialState = {
  ...brandConfig,
  visitorId: getCookie(visitorIdCookie)
} // eslint-disable-line

const getInitialState = () => initialState;

export default function reducer(state = getInitialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/config.js
 **/